import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import {
  Avatar,
  Button,
  Paper,
  Grid,
  Typography,
  Container,
} from '@material-ui/core'
import { useHistory, Link } from 'react-router-dom'
import dotenv from 'dotenv'

import oyeeah from '../../images/oyeeahlogo.svg'
import { signin, signup } from '../../actions/auth'
import useStyles from './styles'
import Input from './Input'

dotenv.config()

const initialState = {
  firstName: '',
  lastName: '',
  email: '',
  password: '',
  confirmPassword: '',
}

const SignUp = () => {
  const [isSignup, setIsSignup] = useState(false)
  const [form, setForm] = useState(initialState)
  const history = useHistory()
  const classes = useStyles()
  const dispatch = useDispatch()

  const [showPassword, setShowPassword] = useState(false)
  const handleShowPassword = () => setShowPassword(!showPassword)

  const switchMode = () => {
    setForm(initialState)
    setIsSignup((prevIsSignup) => !prevIsSignup)
    setShowPassword(false)
  }

  const handleSubmit = (e) => {
    e.preventDefault()

    if (isSignup) {
      dispatch(signup(form, history))
    } else {
      dispatch(signin(form, history))
    }
  }

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value })

  return (
    <Container component='main' maxWidth='xs'>
      <Paper className={classes.paper} elevation={3}>
        <Link to='/'>
          <Avatar className={classes.avatar}>
            <img
              alt='OYEEAH'
              src={oyeeah}
              height='40'
              className={classes.image}
            />
          </Avatar>
        </Link>
        <Typography component='h1' variant='h5'>
          {isSignup ? 'Sign up' : 'Sign in'}
        </Typography>
        <Typography variant='body2' className={classes.subtitle}>
          Please Sign In to create your own rooms and enter other's rooms, it's
          FREE!
        </Typography>
        <form className={classes.form} onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            {isSignup && (
              <Input
                name='username'
                label='Username'
                handleChange={handleChange}
                type='username'
              />
            )}
            <Input
              name='email'
              label='Email Address'
              handleChange={handleChange}
              type='email'
            />

            <Input
              name='password'
              label='Password'
              handleChange={handleChange}
              type={showPassword ? 'text' : 'password'}
              handleShowPassword={handleShowPassword}
            />
            {isSignup && (
              <Input
                name='confirmPassword'
                label='Confirm Password'
                handleChange={handleChange}
                type='password'
              />
            )}
          </Grid>
          <Button
            type='submit'
            fullWidth
            variant='contained'
            className={classes.submit}
          >
            {isSignup ? 'Sign Up' : 'Sign In'}
          </Button>

          <Grid container justifyContent='flex-end'>
            <Grid item>
              <Button onClick={switchMode}>
                {isSignup
                  ? 'Already have an account? Sign in'
                  : "Don't have an account? Sign Up"}
              </Button>
            </Grid>
          </Grid>
        </form>
      </Paper>
    </Container>
  )
}

export default SignUp
